module.exports = __webpack_public_path__ + "img/guam.705c121a.svg";